import CityPageTemplate from "../city-template/CityPageTemplate";
import { rochesterConfig } from "./data";

export default function RochesterPage() {
  return <CityPageTemplate config={rochesterConfig} />;
}